import React from 'react';
import { Container, Logo } from './SplashScreen.styles';
// import { ReactComponent as LogoIcon } from '../../assets/icons/logoSplash.svg';
import { ReactComponent as RingIcon } from '../../assets/icons/ring.svg';
import { ReactComponent as LogoIcon } from '../../assets/icons/logoBlack.svg';

const SplashScreen = () => {
  return (
    <Container>
      <Logo>
        <LogoIcon width={300} height={300} />
      </Logo>
    </Container>
  );
};

export default SplashScreen;
